export const removeDuplicateElementArray = (arr) => {
    const uniqueChars = arr.filter((c, index) => {
        return arr.indexOf(c) === index;
    });
    return uniqueChars;
};
